import { get, toLower } from 'lodash'
import * as Types from 'types'

function isGoogleTranslateEnabled(communityConfig) {
  const community = get(communityConfig, 'subdomain')
  return Types.COMMUNITIES_WITH_TRANSLATION.includes(toLower(community))
}

export default isGoogleTranslateEnabled
